<template>
  <div>
    <div
      v-if="!loading"
      class="output-format d-xl-flex justify-content-xl-evenly py-xl-3"
    >
      <resume-global :objDTO="objDTO" />

      <div class="output-group">
        <div class="output-title">
          <b>Dados do Sinistro</b>
        </div>

        <div>
          <span>Data / Hora Sinistro:</span>
          {{ sinistroData() }}
        </div>
        <div class="output-textArea">
          <span>O que aconteceu:</span>
          {{ objDTO.Sinistro.SinistroDescricao }}
        </div>
        <div>
          <span>Cobertura:</span>
          {{ coverageDesc() }}
        </div>
        <div>
          <span>Evento:</span>
          {{ eventDesc() }}
        </div>
        <div>
          <span>Produto:</span>
          {{ produtoDesc() }}
        </div>
      </div>

      <div class="output-group">
        <div class="output-title">
          <b>Local da Ocorrencia</b>
        </div>
        <!-- IMEI -->
        <div>
          <span>CEP:</span>
          {{ objDTO.Sinistro.SinistroCodigoPostal }}
        </div>
        <div>
          <span>Estado:</span>
          {{ getEstadoDesc(objDTO.Sinistro.SinistroDistritoId) }}
        </div>
        <div>
          <span>Cidade:</span>
          {{ getCidadeSinistro(objDTO.Sinistro.SinistroConcelhoId) }}
        </div>
        <div>
          <span>Bairro:</span>
          {{ getBairrosSinistro(objDTO.Sinistro.SinistroFreguesiaId) }}
        </div>
        <div>
          <span>Logradouro:</span>
          {{ objDTO.Sinistro.SinistroMorada }}
        </div>
        <div>
          <span>Nº :</span>
          {{ objDTO.Sinistro.SinistroMoradaNrPorta }}
        </div>
        <div>
          <span>Complemento:</span>
          {{ objDTO.Sinistro.SinistroLocalReferencia }}
        </div>
      </div>

      <div class="output-group">
        <div class="output-title">
          <b>
            {{
              objDTO.Apolice.ApoliceCoberturaId == 2805
                ? 'Endereço para Envio'
                : 'Endereço para Devolução'
            }}
          </b>
        </div>
        <div>
          <span>CEP:</span>
          {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostal }}
        </div>
        <div>
          <span>Estado:</span>
          {{
            getEstadoDesc(objDTO.ProcessoGDM.ProdutoEnvioContacto.DistritoId)
          }}
        </div>
        <div>
          <span>Cidade:</span>
          {{
            getCidadesEnvio(objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId)
          }}
        </div>
        <div>
          <span>Bairro:</span>
          {{
            getBairrosEnvio(objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId)
          }}
        </div>
        <div>
          <span>Logradouro:</span>
          {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.Morada }}
        </div>
        <div>
          <span>Nº:</span>
          {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.MoradaNrPorta }}
        </div>
        <div>
          <span>Complemento:</span>
          {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.CodPostalLocalidade }}
        </div>
      </div>
    </div>
    <!-- <div
      v-if="!loading && objDTO.Apolice.ApoliceCoberturaId == 2698"
      class="output-format d-xl-flex justify-content-xl-evenly  py-xl-3"
    >
      <div class="output-group-QA">
        <div class="output-title"><b>QAR</b></div>
        <div class="output-question-group">
          <div class="me-3">
            Aparelho possui algum dano físico ou está quebrado?:
          </div>
          <div>
            <i :class="getOption(objDTO.Sinistro.ConstatacaoDanosOpcaoId)"></i>
          </div>
        </div>

        <div class="output-question-group">
          <div class="me-3">
            Aparelho teve algum contato com líquido ou água?:
          </div>
          <div>
            <i :class="getOption(objDTO.Sinistro.GuinchoOpcaoId)"></i>
          </div>
        </div>

        <div class="output-question-group">
          <div class="me-3">
            Aparelho teve algum sinistro ou atendimento técnico anterior?:
          </div>
          <div>
            <i :class="getOption(objDTO.Sinistro.SinistroAnteriorOpcaoId)"></i>
          </div>
        </div>
      </div>
    </div>-->
    <div v-if="!loading" class="col-12 Aligner aligner-right">
      <button
        class="button-base-small btn-gray font-small mx-1"
        @click="voltar"
      >
        Voltar
      </button>
      <button
        class="button-base-small btn-green font-small mx-1"
        @click="finishAviso"
         :disabled="loading"
      >
        Acabar
      </button>
    </div>
    <loading-state-f-s v-else />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
import { createAviso, getPBOs } from '../../api/formMethods';
import LoadingStateFS from '../LoadingStateFS.vue';
import ResumeGlobal from '../ResumeGlobal.vue';
import { handleAberturaResponseWithUploadDocuments } from '../../utils/helpers';
import { AREA_NEGOCIO, PRODUCT_NAME } from '../../utils/constants';

export default {
  components: { LoadingStateFS, ResumeGlobal },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    objDTO: Object,
    events: Array,
    coverages: Array,
    gdmTipo: Array,
    estados: Array,
    cidadesSinistro: Array,
    bairrosSinistro: Array,
    cidadesEnvio: Array,
    bairrosEnvio: Array,
    riskUnits: Array,
    insuranceObjects: Array,
  },
  methods: {
    getOption(value) {
      return value == 1
        ? 'fa fa-check color-green font-large'
        : 'fa fa-times color-orange font-large';
    },
    sinistroData() {
      return dayjs(this.objDTO.Sinistro.SinistroData).format(
        'DD/MM/YYYY HH:mm'
      );
    },
    produtoDesc() {
      return this.gdmTipo.find((x) => x.Id == this.objDTO.ProcessoGDM.GDMTipoId)
        .Description;
    },
    eventDesc() {
      return this.events.find(
        (x) => x.Id == this.objDTO.Sinistro.SinistroEventoId
      ).Description;
    },
    coverageDesc() {
      return this.coverages.find(
        (x) => x.GisCoverageId == this.objDTO.Apolice.ApoliceCoberturaId
      ).Description;
    },
    getEstadoDesc(id) {
      return this.estados.find((x) => x.Id == id).Description;
    },
    getCidadeSinistro() {
      return this.cidadesSinistro.find(
        (x) => x.Id == this.objDTO.Sinistro.SinistroConcelhoId
      ).Description;
    },
    getBairrosSinistro() {
      return this.bairrosSinistro.find(
        (x) => x.Id == this.objDTO.Sinistro.SinistroFreguesiaId
      ).Description;
    },
    getCidadesEnvio() {
      return this.cidadesEnvio.find(
        (x) => x.Id == this.objDTO.ProcessoGDM.ProdutoEnvioContacto.ConcelhoId
      ).Description;
    },
    getBairrosEnvio() {
      return this.bairrosEnvio.find(
        (x) => x.Id == this.objDTO.ProcessoGDM.ProdutoEnvioContacto.FreguesiaId
      ).Description;
    },
    formatDate(date) {
      return dayjs(date)
        .local()
        .format();
    },
    async finishAviso() {
      this.loading = true;
      try{
        this.objDTO.FormAvisoId = 9;
      // this.objDTO.AreaNegocioId = 36;
      // this.objDTO.SubCategoriaId = 3600;
      this.objDTO.Sinistro.SinistroData = this.formatDate(
        this.objDTO.Sinistro.SinistroData
      );
      this.objDTO.Apolice.ApoliceDataInicio = this.formatDate(
        this.objDTO.Apolice.ApoliceDataInicio
      );
      this.objDTO.Apolice.ApoliceDataFim = this.formatDate(
        this.objDTO.Apolice.ApoliceDataFim
      );
      this.objDTO.SeguradoContacto.DataNascimento = this.formatDate(
        this.objDTO.SeguradoContacto.DataNascimento
      );

      // Descricoes

      this.objDTO.Apolice.UnidadeDeRiscoDescricao = this.riskUnits.find(
        (ru) => ru.RiskUnitId == this.objDTO.Apolice.UnidadeDeRiscoExternalId
      ).Description;
      this.objDTO.Apolice.ObjectoSeguradoDescricao = this.insuranceObjects.find(
        (io) =>
          io.InsuranceObjectId == this.objDTO.Apolice.ObjectoSeguradoExternalId
      ).Description;

      /// Auto-select BPO de acordo com com GDMTipoId
      // Get all BPOs
      const bpos = await getPBOs(PRODUCT_NAME.RouboFurto);
      // Filtrar BPO pelo GDMTipoId selecionado e guardar no ReguladoraObjContactoObjId
      const bpo = bpos.find((x) =>
        x.GdmTipoIds.includes(this.objDTO.ProcessoGDM.GDMTipoId)
      );
      this.objDTO.ReguladoraObjContactoObjId = bpo.Id;

      const res = await createAviso(this.objDTO, this.coverages);
      // this.loading = false;

      handleAberturaResponseWithUploadDocuments(res, AREA_NEGOCIO.Partnerships);
      }
      catch(e){
        console.log(e);
      }
      finally{
        this.loading = false;
      }
    },
    voltar() {
      this.$emit('back', 1);
    },
  },
  computed: {},
  // async mounted(){
  //   await getBPO(this.objDTO.ProcessoGDM.GDMTipoId);
  // }
};
</script>
